import { InfoCircleOutlined } from '@ant-design/icons'
import { useFormatter } from '@api/useFormatter'
import { addCommasToNumber, Texto } from '@gravitate-js/excalibrr'
import { Col, Popover, Row } from 'antd'

export const getCalculationDisplay = (detail, formattedUnit) => {
  const displayUnits = detail.override_units || detail.override_units === 0 ? detail.override_units : detail.units
  const showPercent = detail.unit?.includes('%') || detail.unit?.toLowerCase().includes('percent')
  const rate = showPercent ? `${detail.rate * 100}%` : `${formattedUnit}${detail.rate}`
  return (
    <>
      <b>{`${rate} * ${getDisplayValue(displayUnits)}`}</b>{' '}
      {detail.unit !== ''
        ? `(${detail.unit}${detail.threshold_interval ? ` per ${detail.threshold_interval.toLowerCase()}` : ''})`
        : ''}
    </>
  )
}

export const getDisplayValue = (value) => {
  return value % 1 !== 0 ? addCommasToNumber(value.toFixed(2)) : addCommasToNumber(value)
}
export function AmountCol({ showPopover, row }) {
  const { formatCurrency } = useFormatter()
  const formattedUnit = formatCurrency(null, true)

  const dollars = row.override_dollar || row.override_dollar === 0 ? row.override_dollar : row.dollar
  const display = Number(dollars.toFixed(2)).toLocaleString(undefined, { minimumFractionDigits: 2 })
  return (
    <>
      <b>
        {formattedUnit} {display}
      </b>
      {showPopover ? (
        <AutomaticPopover title={row.grouping} details={row.details} formattedUnit={formattedUnit} />
      ) : null}
    </>
  )
}
function AutomaticPopover({ title, details, formattedUnit }) {
  const content = details.map((d, i) => {
    const dollarAmount = d.override_dollars || d.dollars || 0
    const isSubrow = !!d.parent
    const isBonus = title === 'Bonus'
    return (
      <Row key={i} className={`payroll-detail-popover-row ${isSubrow ? 'subrow' : ''}`}>
        <Col span={8} className={isSubrow ? 'payroll-detail-subrow-name' : ''}>
          <span>{d.name}</span>
        </Col>
        <Col align='right' span={11}>
          <Texto weight='bold' align={'right'} className={isSubrow ? '' : 'automatic-calculation'}>
            {isBonus ? `${d.shifts} ${d.unit}s` : getCalculationDisplay(d, formattedUnit)}
          </Texto>
        </Col>
        <Col span={5} align='right' style={{ whiteSpace: 'nowrap' }}>
          <span>
            {formattedUnit} {Number(dollarAmount.toFixed(2)).toLocaleString(undefined, { minimumFractionDigits: 2 })}
          </span>
        </Col>
      </Row>
    )
  })

  return (
    <Popover content={content} title={`${title} Pay Breakdown`}>
      <InfoCircleOutlined className='detail-popover ml-2' />
    </Popover>
  )
}

export function formatSpecialPayRate(rate, unit, formattedCurrency) {
  if (!rate) return ''
  if (unit.includes('percent') || unit.includes('%')) {
    return `${rate * 100}%`
  }
  return `${formattedCurrency}${rate.toFixed(2)}`
}
